import React, {Component} from 'react';
import {FaIcon} from "../FaIcon";
import {ConfigColumnsWidget} from "./ConfigColumnsWidget";
import {LabelsFilterButton} from "./LabelsFilterButton";
import {Spinner} from "../Spinner";
import {DashboardPlatformFilter} from "./DashboardPlatformFilter";
import {ColumnVisibilityButton} from "./ColumnVisibilityButton";
import {ViewInsightsButtonAndModal} from "./ViewInsightsButtonAndModal";
import { withTranslation } from 'react-i18next';

class DashboardFiltersComponent extends Component {
    constructor(props) {
        super(props);

        this.handleTextFilterChange = this.handleTextFilterChange.bind(this);
        this.handleClearTextFilter = this.handleClearTextFilter.bind(this);
        this.handleToggleIssuesOnly = this.handleToggleIssuesOnly.bind(this);
        this.handleLabelsFilterChange = this.handleLabelsFilterChange.bind(this);

        this.state = {
            textFilter: this.props.textFilter,
            issuesOnly: this.props.issuesOnly,
            labelsFilter: this.props.labelsFilter,
            platformFilter: this.props.platformFilter
        };
    }

    componentDidUpdate(prevProps) {
        if (prevProps.textFilter !== this.props.textFilter) {
            this.setState({ textFilter: this.props.textFilter });
        }

        if (prevProps.issuesOnly !== this.props.issuesOnly) {
            this.setState({ issuesOnly: this.props.issuesOnly });
        }

        if (!this.areArraysEqual(prevProps.labelsFilter, this.props.labelsFilter)) {
            this.setState({ labelsFilter: this.props.labelsFilter });
        }

        if (!this.areArraysEqual(prevProps.platformFilter, this.props.platformFilter)) {
            this.setState({ platformFilter: this.props.platformFilter });
        }
    }

    areArraysEqual(arr1, arr2) {
        if (!arr1 && !arr2) return true;
        if (!arr1 || !arr2) return false;
        if (arr1.length !== arr2.length) return false;
        return arr1.every((value, index) => value === arr2[index]);
    }

    handleTextFilterChange(event) {
        const inputValue = event.target.value;
        this.props.onTextFilterChange(inputValue);
    }

    handleClearTextFilter(event) {
        event.preventDefault();
        this.props.onTextFilterChange('');
    }

    handleToggleIssuesOnly(event) {
        event.preventDefault();
        this.props.onToggleIssuesOnly(!this.state.issuesOnly);
    }

    handleLabelsFilterChange(selectedLabels) {
        this.props.onLabelsFilterChange(selectedLabels);
    }

    renderDownloadButton() {
        const { t } = this.props;
        if (this.props.isDownloading) {
            return <Spinner color="positive small"/>;
        }
        return (
            <button
                type="button"
                title={t('dashboard.export_dashboard')}
                onClick={this.props.onDownloadDashboardData}
                className="dashboard-header-option"
            >
                <FaIcon iconName="download"/>
                <p className="header-option-label">{t('dashboard.export')}</p>
            </button>
        );
    }

    renderSyncAllButton() {
        if (!this.props.bulkUserBusinessUnitsSyncEnabled) {
            return null;
        }

        const { t } = this.props;
        return (
            <button
                type="button"
                title={t('dashboard.sync_all_control_lines')}
                onClick={this.props.onSyncAllBusinessUnits}
                className="dashboard-header-option not-synced"
            >
                <FaIcon iconName="sync-alt" style={{fontSize: '0.85em'}}/>
                <p className="header-option-label">{t('dashboard.sync_all')}</p>
            </button>
        );
    }

    renderIssuesOnlyButton() {
        const { t } = this.props;
        const isActive = !!this.state.issuesOnly;
        const buttonClass = "issues-only-button" + (isActive ? ' -active' : '');
        return (
            <button
                type="button"
                className={buttonClass}
                onClick={this.handleToggleIssuesOnly}
                title={t('dashboard.view_only_urgent')}
                aria-pressed={isActive}
            >
                <FaIcon iconName="exclamation-triangle"/>
            </button>
        );
    }

    renderModuleInsightsComponents() {
        if (this.props.moduleInsightsEnabled !== true) return null;
        return <ViewInsightsButtonAndModal/>;
    }

    render() {
        const { t } = this.props;
        return (
            <form className="filter-options dashboard-filter-bar" onSubmit={(e) => e.preventDefault()}>
                <div className="dashboard-filter-bar-left">
                    <div className="dashboard-search-input">
                        <label><FaIcon iconName="search"/></label>
                        <input
                            name="search"
                            type="text"
                            placeholder={t('dashboard.search_placeholder')}
                            onChange={this.handleTextFilterChange}
                            value={this.state.textFilter}
                        />
                        {this.state.textFilter && (
                            <button type="button" className="dashboard-search-clear" onClick={this.handleClearTextFilter}>
                                <FaIcon iconName="times-circle"/>
                            </button>
                        )}
                    </div>
                    <DashboardPlatformFilter
                        onPlatformFilterChange={this.props.onPlatformFilterChange}
                        platformFilter={this.state.platformFilter}
                        availablePlatforms={this.props.availablePlatforms}
                    />
                    {this.renderIssuesOnlyButton()}
                    <ColumnVisibilityButton
                        activeColumns={this.props.activeColumns}
                        hiddenColumns={this.props.hiddenColumns}
                        onHiddenColumnsChange={this.props.onHiddenColumnsChange}
                    />
                </div>
                <div className="dashboard-filter-bar-right">
                    <LabelsFilterButton
                        onApplyFilter={this.handleLabelsFilterChange}
                        selectedLabels={this.state.labelsFilter}
                    />
                    <ConfigColumnsWidget
                        activeColumns={this.props.activeColumns}
                        activeColumnsSetId={this.props.activeColumnsSetId}
                        handleColumnStateChange={this.props.handleColumnStateChange}
                        onColumnsPositionChange={this.props.onColumnsPositionChange}
                        columnsSets={this.props.columnsSets}
                        onSelectColumnSet={this.props.onSelectColumnSet}
                        onSaveColumnSet={this.props.onSaveColumnSet}
                        onDeleteColumnSet={this.props.onDeleteColumnSet}
                        flexIndicators={this.props.flexIndicators}
                        ga4Indicators={this.props.ga4Indicators}
                        ecommerceIndicators={this.props.ecommerceIndicators}
                        paidMediaIndicators={this.props.paidMediaIndicators}
                        metaIndicators={this.props.metaIndicators}
                        canEditFlexIndicators={this.props.canEditFlexIndicators}
                    />
                    {this.renderModuleInsightsComponents()}
                    {this.renderDownloadButton()}
                    {this.renderSyncAllButton()}
                </div>
            </form>
        );
    }
}

export const DashboardFilters = withTranslation()(DashboardFiltersComponent);
